const isCartNotFoundError = (errorOrDetail) => {
    const data = errorOrDetail?.data ?? errorOrDetail;
    const apiError = data?.errors?.[0] ?? (data?.type ? data : null);

    if (!apiError || apiError.reason !== 'notFound') {
        return false;
    }

    return (
        apiError.subjectType === 'cart' ||
        apiError.type === 'CartError'
    );
};

export default isCartNotFoundError;
